import Territories from './Territories';

export default Territories;
